@if (product) {
  <section class="pd-section">
    <div class="container">

      <a class="pd-back" [routerLink]="'/home/articles'">
        <mat-icon>arrow_back</mat-icon>
        <span>{{ 'back' | translate }}</span>
      </a>

      <div class="row pd-row">

        <!-- Galería -->
        <div class="col-lg-6">
          <div class="pd-gallery-card">

            <div class="pd-img-wrap">
              <ngx-slick-carousel class="product-slick" #slickModal="slick-carousel" [config]="slideConfig">
                @for (image of getPhotosArray(product.photos); track image) {
                  <div ngxSlickItem>
                    <div class="pd-slide-inner">
                      <img [src]="geturl(image)" [alt]="product.name" class="pd-img">
                    </div>
                  </div>
                }
              </ngx-slick-carousel>
            </div>

            @if (getPhotosArray(product.photos).length > 1) {
              <div class="pd-thumbs">
                <ngx-slick-carousel class="slider-nav" #slickNavModal="slick-carousel" [config]="slideNavConfig">
                  @for (image of getPhotosArray(product.photos); track image) {
                    <div ngxSlickItem>
                      <div class="pd-thumb">
                        <img [src]="geturl(image)" alt="">
                      </div>
                    </div>
                  }
                </ngx-slick-carousel>
              </div>
            }

          </div>
        </div>

        <!-- Info -->
        <div class="col-lg-6">
          <div class="pd-info">

            @if (product.sku) {
              <span class="pd-sku">SKU {{ product.sku }}</span>
            }

            <h1 class="pd-name">{{ product.name }}</h1>

            @if (product.description) {
              <p class="pd-desc">{{ product.description }}</p>
            }

            <div class="pd-divider"></div>

            @if (validatePrice(product)) {
              <div class="pd-price-row">
                <span class="pd-price">{{ getPrice(product) | currency }}</span>
                @if (isAvailableResult) {
                  <span class="pd-badge pd-badge--ok">
                    <mat-icon>check_circle</mat-icon>
                    Disponible
                  </span>
                } @else {
                  <span class="pd-badge pd-badge--no">
                    <mat-icon>remove_circle_outline</mat-icon>
                    Sin stock
                  </span>
                }
              </div>
            }

            @if (product.sizes && product.sizes.length > 0) {
              <div class="pd-options">
                <span class="pd-options-label">Talle</span>
                <div class="pd-pills">
                  @for (size of product.sizes; track size) {
                    <button class="pd-pill" [class.pd-pill--active]="selectedSize === size" (click)="selectedSize = size">{{ size }}</button>
                  }
                </div>
              </div>
            }

            @if (validatePrice(product) && isAvailableResult) {
              <div class="pd-buy-rail">
                <div class="pd-qty">
                  <button class="pd-qty-btn" (click)="counter = counter > 1 ? counter - 1 : 1">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <span class="pd-qty-num">{{ counter }}</span>
                  <button class="pd-qty-btn" (click)="counter = counter + 1">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
                <button class="pd-cta" (click)="addToCart(product, counter)">
                  <mat-icon>shopping_cart</mat-icon>
                  {{ 'cart-add' | translate }}
                </button>
              </div>
            }

            @if (!isAvailableResult) {
              <div class="pd-unavailable-msg">
                <mat-icon>info_outline</mat-icon>
                <span>Este producto no está disponible para tu cuenta en este momento.</span>
              </div>
            }

          </div>
        </div>

      </div>
    </div>
  </section>
}
